import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { StatusColors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import { PredefinedHitSlops } from '@euler/functions/predefinedHitSlops';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { SettlementForm } from '@euler/model/task-detail';
import { memo, useMemo } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const SettlementFormFooter = memo(
  ({
    form,
    style,
    onViewQuotationForm,
    onPrint,
  }: {
    form: SettlementForm;
    style?: StyleProp<ViewStyle>;
    onViewQuotationForm: () => void;
    onPrint: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const styles = useStyles();

    return (
      <StackLayout
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        style={[styles.container, style]}
        css={`
          box-shadow: 0 0 ${rpx(15)}px rgba(0, 0, 0, 0.25);
        `}
      >
        <StackLayout>
          <StackLayout direction="row" alignItems="center" gap={rpx(4)}>
            <Typography.Text
              style={styles.totalLabel}
            >{`合计:`}</Typography.Text>
            <Typography.Text style={styles.total}>{`￥${(
              form.computedTotalFee / 100
            ).toFixed(2)}`}</Typography.Text>
          </StackLayout>
          <StackLayout direction="row" alignItems="center">
            <Typography.Text
              style={styles.priceLabel}
              size={rpx(10)}
              light
            >{`工时费: ￥${(form.totalManHourCostFee / 100).toFixed(
              2,
            )}, `}</Typography.Text>
            <Typography.Text
              style={styles.priceLabel}
              size={rpx(10)}
              light
            >{`配件费: ￥${(form.totalMaterialFee / 100).toFixed(
              2,
            )}`}</Typography.Text>
          </StackLayout>
        </StackLayout>
        <StackLayout direction="row" gap={0}>
          <Center.Touchable
            hitSlop={PredefinedHitSlops.large}
            onPress={onViewQuotationForm}
            css={`
              padding: 0 ${rpx(10)}px;
            `}
          >
            <Typography.Text medium>报价单</Typography.Text>
          </Center.Touchable>
          <Center.Touchable
            onPress={onPrint}
            css={`
              background-color: ${StatusColors.Info};
              height: ${rpx(44)}px;
              border-radius: ${rpx(44)}px;
              padding: 0 ${rpx(20)}px;
            `}
          >
            <Typography.Text color="#fff" bold size={rpx(18)}>
              打印结算单
            </Typography.Text>
          </Center.Touchable>
        </StackLayout>
      </StackLayout>
    );
  },
);

const useStyles = () => {
  const { rpx } = useResponsiveContext();
  const { bottom } = useSafeAreaInsets();
  return useMemo(
    () =>
      StyleSheet.create({
        container: {
          backgroundColor: '#f9f9f9',
          paddingHorizontal: rpx(15),
          paddingBottom: Math.max(rpx(15), bottom * 0.75 + rpx(4)),
          paddingTop: rpx(15),
        },
        totalLabel: {
          fontSize: rpx(12),
          color: '#333',
        },
        total: {
          color: StatusColors.Danger,
          fontSize: rpx(23),
          fontFamily: FontFamily.NotoSans.Black,
          top: rpx(-2),
          fontWeight: '800',
          letterSpacing: rpx(-1.5),
        },
        priceLabel: {
          color: '#333',
          fontSize: rpx(10),
        },
        totalDiscount: {
          fontSize: rpx(12),
          color: StatusColors.Danger,
        },
      }),
    [bottom, rpx],
  );
};
